import overviewImg from "./overview.jpg"
import "./Overview.css"
import { useStore } from "../../components/Orbit/orbitStore"
import Arrows from "../../components/Icons/navy_double_arrow_left.svg"

import { useEffect, Suspense } from "react"
import Orbits from "../../components/Orbit/Orbits"

import { BackButton, BackIcon } from "../ShowApartment/ShowApartment.style"
// import { Suspense } from "react"
const CONFIG_URL = `${process.env.PUBLIC_URL}/orbits/orbits.json`
const exploreIcon = `${process.env.PUBLIC_URL}/assets/images/landing/postmark.svg`
const Overview = () => {
  const setShow = useStore(state => state.setShow)
  const showOverview = useStore(state => state.showOverview)

  useEffect(() => {
    return () => {
      // console.log("unmount", showOverview)
      setShow(true)
    }
  }, [])
  return (
    <div className="overview-screen">
      {showOverview && (
        <>
          <img style={{ zIndex: 100 }} src={overviewImg} alt="" className="background" />
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              top: "30%",
              left: "60%",
              width: "140px",
              height: "140px",
              zIndex: "200"
            }}
            onClick={() => setShow(false)}
          >
            <img src={exploreIcon} alt="Explore" />
          </div>
        </>
      )}
      <Suspense fallback={null}>
        <Orbits configUrl={CONFIG_URL} />
      </Suspense>
      <BackButton onClick={() => setShow(true)}>
        <BackIcon src={Arrows} />
      </BackButton>
    </div>
  )
}

export default Overview
